import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { InputNumberModule } from 'primeng/inputnumber';
import { DropdownModule } from 'primeng/dropdown';
import { TranslateModule } from '@ngx-translate/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { MovementLocation } from 'src/app/models/movement/movement-location';

@Component({

  selector: 'app-berth-map-vacancy-form',
  templateUrl: './berth-map-vacancy-form.component.html',
  styleUrls: ['./berth-map-vacancy-form.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    InputTextModule,
    ButtonModule,
    InputNumberModule,
    DropdownModule,
    TranslateModule
  ]
})
export class BerthMapVacancyFormComponent implements OnInit {
  movementLocations: MovementLocation[];
  vacancyForm: FormGroup;
  x: number;
  y: number;
  isEditMode: boolean = false;

  constructor(
    private ref: DynamicDialogRef,
    private config: DynamicDialogConfig,
    private fb: FormBuilder,
  ) {}

  async ngOnInit() {
    const data = this.config.data || {};
    this.movementLocations = data.movementLocations || [];
    this.x = data.x || 0;
    this.y = data.y || 0;
    this.isEditMode = !!data.vacancy;

    const vacancy = data.vacancy || {};
    
    this.vacancyForm = this.fb.group({
      movementLocation: new FormControl(null, Validators.required),
      code: [vacancy.code || '', Validators.required],
      maxBoatLength: [vacancy.length || null, [Validators.required, Validators.min(0)]],
      berthMapWidth: [data.berthMapWidth || null, [Validators.required, Validators.min(0)]],
      berthMapHeight: [data.berthMapHeight || null, [Validators.required, Validators.min(0)]]
    });
  }

  save() {
    if (this.vacancyForm.valid) {
      const formValue = this.vacancyForm.value;
      const newVacancy = {
        ...formValue,
        code: formValue.code,
        x: this.x,
        y: this.y
      };
      this.ref.close(newVacancy);
    }
  }

  onCancel() {
    this.ref.close();
  }
}